import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}/execution-report`

const apiSelectFilter = () => http.get(`${api}/select-filter`)

const apiAuthorizationReason = (options) => http.get(
  `${api}/authorization-reason`,
  { params: { ...options } })

const apiTopDoctors = (options) => http.get(
  `${api}/top-doctors`,
  { params: { ...options } })

const apiTopIps = (options = {}) => http.get(`${api}/top-ips`, { params: { ...options } })
const apiResumeTotales = (options) => http.get(
  `${api}/totals`,
  { params: { ...options } })

const apiPatologia = (options = {}) => http.get(`${api}/consumption-pathology`, { params: { ...options } })

const apiTecnicoVigilancia = (queryParams = {}) => http.get(`${api}/blood-glucose-chart`, { params: { ...queryParams } })
const apiTopTecnicoVigilancia = (queryParams = {}) => http.get(`${api}/top-blood-glucose-chart`, { params: { ...queryParams } })

const apiFarmacoVigilancia = (queryParams = {}) => http.get(`${api}/interactions-chart`, { params: { ...queryParams } })
const apiTopFarmacoVigilancia = (queryParams = {}) => http.get(`${api}/topinteractions-chart`, { params: { ...queryParams } })
const apiTopFarmacoVigilanciaMayor = (queryParams = {}) => http.get(`${api}/topinteractions-mayor`, { params: { ...queryParams } })
const apiTopFarmacoVigilanciaDescription = (queryParams = {}) => http.get(`${api}/topinteractions-description`, { params: { ...queryParams } })
const apiTopPoliformulados = (options = {}) => http.get(`${api}/top-poliformulados`, { params: { ...options } })

const apiPacientesDiagnostico = (options = {}) => http.get(`${api}/pacientes-diagnostico`, { params: { ...options } })
const apiPacientesPoliformulados = (options = {}) => http.get(`${api}/pacientes-poliformulados`, { params: { ...options } })
const apiAnalisispoliformulacion = (options = {}) => http.get(`${api}/analisis-poliformulacion`, { params: { ...options } })

export {
  apiSelectFilter,
  apiAuthorizationReason,
  apiTopDoctors,
  apiTopIps,
  apiResumeTotales,
  apiPatologia,
  apiTecnicoVigilancia,
  apiTopTecnicoVigilancia,
  apiFarmacoVigilancia,
  apiTopFarmacoVigilancia,
  apiTopFarmacoVigilanciaMayor,
  apiTopFarmacoVigilanciaDescription,
  apiTopPoliformulados,
  apiPacientesDiagnostico,
  apiPacientesPoliformulados,
  apiAnalisispoliformulacion
}
